"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheQueryVariables = exports.getCachedQueryVariables = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const QueryVariables_fragment_graphql_1 = __importDefault(require("./resolvers/queryVariables/QueryVariables.fragment.graphql"));
const QueryVariables_mutation_graphql_1 = __importDefault(require("./resolvers/queryVariables/QueryVariables.mutation.graphql"));
const ObjectHelper_1 = require("@aurora/shared-utils/helpers/objects/ObjectHelper");
/**
 * A function to get query variables from the cached query.
 *
 * @param cache an ApolloCache instance.
 * @param cacheKey The cache key to look up the query variables
 *
 * @author Dolan Halbrook
 */
function getCachedQueryVariables(cache, cacheKey) {
    try {
        const variables = cache.readFragment({
            id: `QueryVariables:${cacheKey}`,
            fragment: QueryVariables_fragment_graphql_1.default
        });
        return variables === null || variables === void 0 ? void 0 : variables.value;
    }
    catch (_a) {
        return null;
    }
}
exports.getCachedQueryVariables = getCachedQueryVariables;
/**
 * Store query variables.
 *
 * @param client An Apollo client instance.
 * @param cacheKey A cache key for storing the query variables.
 * @param variables The variables to store.
 * @param skip Whether or not to skip the query that stores the variables.
 * @author Dolan Halbrook
 */
function cacheQueryVariables(client, cacheKey, variables, skip) {
    if (!skip && !(0, ObjectHelper_1.isObjectEmpty)(variables) && cacheKey) {
        const existingQueryVars = getCachedQueryVariables(client.cache, cacheKey);
        if (!existingQueryVars || !(0, react_fast_compare_1.default)(variables, existingQueryVars)) {
            const mutationVariables = {
                cacheKey,
                value: variables
            };
            client.mutate({
                mutation: QueryVariables_mutation_graphql_1.default,
                variables: mutationVariables
            });
        }
    }
}
exports.cacheQueryVariables = cacheQueryVariables;
//# sourceMappingURL=cacheQueryVariables.js.map